import { EditorUiStore } from './types';

export const actionsSelector = (s: EditorUiStore) => s.actions;

export const activeWordIdSelector = (s: EditorUiStore) => s.activeWordId;

export const scrollRequestSelector = (s: EditorUiStore) => s.scrollRequest;

export const scrollToWordIdSelector = (s: EditorUiStore) =>
  scrollRequestSelector(s)?.wordId;

export const scrollToWordContextSelector = (s: EditorUiStore) =>
  scrollRequestSelector(s)?.context;

export const showDeletedWordsSelector = (s: EditorUiStore) =>
  s.showDeletedWords;

const scrollingSegmentWordIdSelectort = (s: EditorUiStore) =>
  s.scrollingSegmentWordId;

export const isScrollingSegmentSelector = (s: EditorUiStore) =>
  scrollingSegmentWordIdSelectort(s) !== undefined;
